if (!window.__cart_popup_inited__) {
  window.__cart_popup_inited__ = true;

  document.addEventListener('alpine:init', () => {
    window.cartPopup = () => ({
      isOpen: false,
      products: [],
      threshold: 0,
      cartTotal: 0,
      view: 'none',
      timer: null,
      isLoading: true,

      money(centsOrFloat) {
        // cents preferred
        const cents = Number.isFinite(centsOrFloat) ? Number(centsOrFloat) : 0;

        if (window.Shopify?.formatMoney) {
          try {
            return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}");
          } catch {}
        }

        // Active currency
        let currency = window.Shopify?.currency?.active || 'USD';
        if (currency === 'AUD' || currency === 'NZD') currency = 'USD';

        const amount = cents / 100;

        // === EURO ===
        if (currency === 'EUR') {
          let formatted = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(amount);

          formatted = formatted.replace(/\s?€/, '');
          formatted = `€${formatted}`;

          return formatted.trim();
        }

        const formatted = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);

        return formatted.trim();
      },

      get awayText() {
        if (!this.threshold) return '$XX';
        const remain = Math.max(this.threshold - this.cartTotal, 0);
        return `$${remain.toFixed(2)}`;
      },

      init() {
        window.showCustomPopup = (payload) => this.open(payload);
        
        // Sync total cart from custom event (optional)
        document.addEventListener('cart:updated', (e) => {
          const cart = e?.detail?.cart;
          if (cart) this.cartTotal = cart.total_price / 100;
        });

        // Close popup when click overlay
        this.$root.addEventListener('click', (ev) => {
          if (ev.target === this.$root) this.close();
        });

        // Auto-close when Rebuy Smart Cart show
          const observer = new MutationObserver(() => {
            if(window.innerWidth > 500){
              if (document.body.classList.contains('rebuy-cart-visible')) this.close();
            } else {
              if (this.view === 'almost') {
                this.ready = false;
              }
            }
          });
          observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      },

      // ====== Normalize helpers ======
      _mapItem(raw) {
        // Try featured_image / image structure
        const image =
          raw?.image ||
          raw?.featured_image?.url ||
          raw?.featured_image ||
          raw?.image_url || '';

        const quantity = Number(raw?.quantity ?? 1);
        const price = Number(
          raw?.price ?? raw?.final_price ?? raw?.original_price ?? 0
        );
        const line_price = Number(
          raw?.line_price ?? (price * quantity)
        );

        return {
          id: raw?.id,
          key: raw?.key,
          image,
          title: raw?.product_title || raw?.title || 'Untitled',
          variant_title: raw?.variant_title || '',
          quantity,
          price,
          line_price,
        };
      },

      _setProducts(arr) {
        this.products = arr.map(this._mapItem);
        this.subtotal = this.products.reduce((s, it) => s + (Number(it.line_price) || 0), 0);
      },

      ready: false,
      view: 'none',
      unwatchPercent: null,

      get percent() {
        const p = Number(Alpine.store('progress')?.percent);
        return Number.isFinite(p) ? p : NaN;
      },

      decideImmediate() {
        const p = this.percent;
        
        if (!Number.isFinite(p)) {
          this.ready = false;
          this.view = 'none';
          return;
        }
        
        this.ready = true;
        if (p >= 100) {
          this.view = 'hooray';
        } else if (p >= 0 && p < 100) {
          this.view = 'almost';
        } else {
          this.view = 'none';
        }
      },

      open(payload) {
        if(window.innerWidth > 500){
          if (document.body.classList.contains('rebuy-cart-visible')) return;
        }
        
        if (payload && Array.isArray(payload.items)) {
          this._setProducts(payload.items);
        } else if (payload && (payload.key || payload.id || payload.title)) {
          this._setProducts([payload]);
        } else {
          this._setProducts([]);
        }

        this.isOpen = true;
        this.isLoading = true;
        console.log("PERCENT : " + Alpine.store('progress').percent);
        if (Number(Alpine.store('progress')?.percent || 0)===100){
          this.isLoading = false;
          this.decideImmediate();
        }

        // Clean watcher
        if (typeof this.unwatchPercent === 'function') {
          this.unwatchPercent();
          this.unwatchPercent = null;
        }

        // Watcher single
        this.unwatchPercent = this.$watch(
          () => Number(Alpine.store('progress')?.percent || 0),
          () => {
            this.isLoading = false;
            this.$nextTick(() => this.decideImmediate());
          }
        );

        if (Alpine.store('ui')?.popupOpen !== undefined) {
          Alpine.store('ui').popupOpen = true;
        }
      },

      close() {
        this.isOpen = false;
        this.ready = false;
        this.view = 'none';

        if (typeof this.unwatchPercent === 'function') {
          this.unwatchPercent();
          this.unwatchPercent = null;
        }

        if (Alpine.store('ui')?.popupOpen !== undefined) {
          Alpine.store('ui').popupOpen = false;
        }
      },
    });
  });
}
